/*eslint-disable*/
import { GET_ALL_ROLES, GET_ROLE, PAGINATE_ROLES, UPDATE_ROLE } from "../actionTypes";
import i18n from "../../i18n.js";

import axios from "axios";
import { baseUriUsers, envHost, loginUri } from "../../uri";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

export const getAllRoles = () => async (
  dispatch: (arg0: { type: string; payload: any }) => void
) => {
  try {
    const res = await axios.get(
      `${baseUriUsers}/service-user/v1/default-authorizations?page=0&size=7`
    );
    dispatch({
      type: GET_ALL_ROLES,
      payload: res.data,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }
    if (e.response.status === 403) {
      toast.error(i18n.t("ERROR_MESSAGES.TOKEN"), {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }
};

export const paginateRoles = (pageNumber: any) => async (
  dispatch: (arg0: { type: any; payload: any }) => void
) => {
  try {
    const res = await axios.get(
      `${baseUriUsers}/service-user/v1/default-authorizations?page=${
        pageNumber - 1
      }&size=7`
    );
    dispatch({
      type: PAGINATE_ROLES,
      payload: res.data,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const getRole = (id: string) => async (
  dispatch: (arg0: { type: string; payload: any }) => void
) => {
  try {
    const res = await axios.get(
      `${baseUriUsers}/service-user/v1/default-authorizations/${id}`
    );
    dispatch({
      type: GET_ROLE,
      payload: res.data,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};

export const updateRole = (role: any, name: string, value: string) => async (
  dispatch: (arg0: { type: string; payload: any }) => void
) => {
  try {
    role[name] = value;
    const res = await axios.put(
      `${baseUriUsers}/service-user/v1/default-authorizations/${role.id}`,
      role
    );
    dispatch({
      type: UPDATE_ROLE,
      payload: res.data,
    });
  } catch (e) {
    if (e.response.status === 401) {
      Cookies.remove("authToken");
      Cookies.remove("accessToken");
      window.location.href = `${loginUri}${envHost}`;
    }
    toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  }
};
